import { BaseCustomElement } from "brut-js"
import PlanEditorComponent from "./PlanEditorComponent"

class TonightComponent extends BaseCustomElement {
  static tagName = "cc-tonight-component"
  static observedAttributes = [
    "show-warnings",
    "date",
  ]


  #date = null

  dateChangedCallback({newValue}) {
    this.#date = newValue
  }

  #refresh = (event) => {
    const url = new URL(window.location.href)
    url.searchParams.set("updated_plan_date", this.#date)
    window.location = url.toString()
  }


  onConnected() {
    const planEditor = this.#planEditor()
    if (!planEditor) {
      this.logger.warn("No plan editor found for tonight component.")
      return
    }
  }

  #planEditor() {
    if (this.#date) {
      return document.querySelector(PlanEditorComponent.selectorForDate(this.#date))
    }
    else {
      return null
    }
  }

  #openToday = (event) => {
    event.preventDefault()
    if (this.#date) {
      const planEditor = this.#planEditor()
      if (planEditor) {
        const details = planEditor.querySelector("details")
        if (details) {
          details.setAttribute("open", "true")
          details.scrollIntoView()
          event.preventDefault()
        }
        else {
          this.logger.warn("plan editor found, but no details element to open.")
        }
      }
      else {
        this.logger.warn(`No plan editor found for date '${this.#date}'`)
      }
    }
    else {
      this.logger.warn("No date set for tonight component, cannot open plan editor.")
    }
  }

  update() {
    const updateLink = this.querySelector("a[href]")
    if (updateLink) {
      updateLink.addEventListener("click", this.#openToday)
      const planEditor = this.#planEditor()
      if (planEditor) {
        planEditor.addEventListener("cc:planupdated", this.#refresh)
      }
    }
  }

}
export default TonightComponent
